// extracted by mini-css-extract-plugin
export var button = "p4f-module--button--m4qFV";
export var buttonWrap = "p4f-module--buttonWrap--eKVYR";
export var goodluck = "p4f-module--goodluck--CiMxw";
export var mqMaxMd = "screen and (max-width: 48em)";
export var p4f = "p4f-module--p4f--6H5z-";
export var title = "p4f-module--title--OMsC2 intro-module--title--9TLn1";